import classnames from 'classnames';
import React from 'react';
export default class Progress extends React.Component {
    componentDidMount() {
        if (this.props.appearTransition) {
            setTimeout(() => {
                if (this.barRef) {
                    this.barRef.style.width = `${this.props.percent}%`;
                }
            }, 10);
        }
        this.noAppearTransition = true;
    }
    render() {
        const { className, prefixCls, showPercent, unfilled, style = {}, barStyle = {}, percent, } = this.props;
        const percentStyle = {
            width: this.noAppearTransition || !this.props.appearTransition
                ? `${percent}%`
                : 0,
        };
        const wrapCls = classnames(`${prefixCls}-outer`, className, {
            [`${prefixCls}-hide-outer`]: !unfilled,
        });
        return (<div className={wrapCls} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} style={style}>
        <div ref={el => (this.barRef = el)} className={`${prefixCls}-bar`} style={Object.assign(Object.assign({}, barStyle), percentStyle)}>
          {showPercent && !!percent ? <span>{percent}%</span> : null}
        </div>
      </div>);
    }
}
Progress.defaultProps = {
    prefixCls: 'cfm_progress',
    percent: 0,
    unfilled: true,
    appearTransition: false,
    showPercent: true,
    style: {},
};



// WEBPACK FOOTER //
// ./components/progress/index.tsx